import React, { useEffect, useState } from "react";
import { useContextData } from "../hooks/useContextData";
import Header from "../components/Header";
import {
  Avatar,
  Button,
  LinearProgress,
  Skeleton,
  Typography,
} from "@mui/material";
import { useUserData } from "../hooks/useUserData";
import { useNavigate } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import ContactModal from "../components/ContactModal";

const Account = () => {
  const { theme, userInfo } = useContextData();
  const { fetchUserInfo, loadingUser } = useUserData();
  const navigate = useNavigate();
  const [contactVisible, setContactVisible] = useState(false);

  useEffect(() => {
    if (!userInfo.id) {
      fetchUserInfo();
    }
  }, []);

  const refreshTime = new Date(userInfo.refreshedAt).toLocaleTimeString(
    undefined,
    {
      hour: "2-digit",
      minute: "2-digit",
    },
  );

  const skeletonProps = {
    sx: {
      bgcolor:
        theme === "dark" ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.11)",
    },
  };

  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "#00050F" : "white",
        color: theme === "dark" ? "#FAFAFA" : undefined,
        height: "100vh",
      }}
    >
      <Header />
      <ContactModal open={contactVisible} setOpen={setContactVisible} />
      {loadingUser && <LinearProgress variant="indeterminate" />}
      <Typography variant="h4" style={{ marginTop: 15, marginBottom: 15 }}>
        Your account
      </Typography>
      <Avatar
        alt="Avatar"
        src={userInfo?.picture || ""}
        style={{
          width: 100,
          height: 100,
          margin: "auto",
          marginBottom: 20,
        }}
      />
      <Typography
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "4px",
        }}
      >
        You have{" "}
        <b>
          {loadingUser ? (
            <Skeleton
              variant="text"
              width={10}
              {...skeletonProps}
              // style={{ display: "inline-block" }}
            />
          ) : (
            userInfo.tokens
          )}
        </b>{" "}
        remaining searches
      </Typography>
      {loadingUser ? (
        <Skeleton
          style={{
            margin: "auto",
            display: "block",
            marginBottom: -20,
          }}
          {...skeletonProps}
          variant="text"
          width={150}
          height={20}
        />
      ) : (
        <Typography variant="caption">
          {refreshTime ? `Refreshed at ${refreshTime}` : "..."}{" "}
        </Typography>
      )}
      <br />
      <Button
        // loading={loading}
        endIcon={<ShoppingCartIcon style={{ height: 24, width: 24 }} />}
        variant="contained"
        onClick={() => navigate("/pricing")}
        sx={{
          alignSelf: "center",
          height: 40,
          width: 150,
          marginTop: 4,
          //   fontSize: 17,
        }}
        style={{
          background: "linear-gradient(to right bottom, #BEC4D0, #737D91)",
        }}
      >
        Buy more
      </Button>
      <Button
        endIcon={<ContactSupportIcon style={{ height: 24, width: 24 }} />}
        variant="text"
        onClick={() => setContactVisible(true)}
        sx={{
          height: 40,
          width: 200,
          marginTop: 4,
          marginLeft: "auto",
          bottom: 10,
          right: 10,
          position: "absolute",
        }}
      >
        Contact support
      </Button>
    </div>
  );
};

export default Account;
//
